import devxHomeIcon from 'assets/images/devX_home.svg';
import devxLaunchpadIcon from 'assets/images/devX_launchpad.svg';
import devxDailyIcon from 'assets/images/devX_daily.svg';
import devXAiIcon from 'assets/images/devX_ai.svg';
import devXApiMarketplaceIcon from 'assets/images/devx-api-marketplace.svg';
import accessPortalIcon from 'assets/images/access-portal.svg';
// import allInclusiveIcon from 'assets/images/all_inclusive.svg';
// import adminPanelSettingsIcon from 'assets/images/admin_panel_settings.svg';

export const appListItems = [
    {
        image: devxHomeIcon,
        label: 'Home',
        path: process.env.REACT_APP_DEVX_HOME,
        disabled: false,
        customIcon: false,
    },
    // {
    //     icon: adminPanelSettingsIcon,
    //     label: 'DevX  - Admin',
    //     // path: process.env.REACT_APP_DEVX_ADMIN,
    //     disabled: true,
    //     customIcon: false,
    // },
    // {
    //     icon: allInclusiveIcon,
    //     label: 'Agile',
    //     // path: process.env.REACT_APP_DEVX_AGILE,
    //     disabled: true,
    //     customIcon: false,
    // },
    {
        image: devxLaunchpadIcon,
        label: 'Launchpad',
        path: process.env.REACT_APP_DEVX_LAUNCHPAD,
        disabled: false,
        customIcon: false,
    },
    {
        image: devxDailyIcon,
        label: 'Daily',
        path: process.env.REACT_APP_DEVX_DAILY,
        disabled: false,
        customIcon: true,
    },
    {
        image: devXAiIcon,
        label: 'AI',
        path: process.env.REACT_APP_DEVX_AI,
        disabled: false,
        customIcon: true,
    },
    {
        image: accessPortalIcon,
        label: 'Access Portal',
        path: process.env.REACT_APP_ACCESS_PORTAL,
        disabled: false,
        customIcon: true,
    },
    {
        image: devXApiMarketplaceIcon,
        label: 'API Marketplace',
        path: process.env.REACT_APP_DEVX_API_MARKETPLACE,
        disabled: false,
        customIcon: true,
    },
];

export const APP_MENU_POPOVER_TITLE = 'DevX Apps';
